import type { FormFlow, FmpFormStep } from '../../../types/form'
import { FormTypeEnum } from '@strata-monorepo/shared-types'
import { homeInfo } from '../questions/homeInfo'

export const FMP_FORM_NAME = 'fmp_v1'

export const createHomeInfoQuiz = (): FormFlow => {
  const homeInfoQuestion: FmpFormStep = {
    ...homeInfo,
    coreIf: true,
    visibleIf: undefined,
    componentProps: {
      ...homeInfo.componentProps,
      shouldFetchConsumptionPrediction: true,
      tracking: {
        ...homeInfo.componentProps.tracking,
        deepStepNumber: 1,
        quickStepNumber: 1,
        deepStepId: '1',
        quickStepId: '1',
      },
    },
  }

  const homeInfoQuestions: FmpFormStep[] = [homeInfoQuestion]

  return {
    version: FMP_FORM_NAME,
    questions: homeInfoQuestions,
    formType: FormTypeEnum.HOME_INFO,
    progressDisplay: { mode: 'step', showSteps: false, showProgressBar: false },
  }
}
